import request from 'src/api/utils';
import * as ROUTES from 'src/api/routes';
import { AiPrompt } from 'src/queries/useAiPrompts';

export async function getPrompts() {
    const result = await request({
        ...ROUTES.GET_PROMPTS,
    });

    return result.data;
}

export async function getPromptById(promptId: string) {
    const result = await request({
        ...ROUTES.GET_PROMPT_BY_ID,
        pathParams: { promptId },
    });

    return result.data;
}

export async function createPrompt(promptData: Partial<AiPrompt>) {
    return await request({
        ...ROUTES.CREATE_PROMPT,
        data: { ...promptData },
    });
}

export async function updatePrompt(promptId: string, promptData: Partial<AiPrompt>) {
    return await request({
        ...ROUTES.UPDATE_PROMPT,
        pathParams: { promptId },
        data: { ...promptData },
    });
}
